// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * The line-maths check that stays (design D21): quantity × rate must equal the printed amount.
 * Missing numbers are "cannot check", never a mismatch. Pure.
 */
function num(v) {
  const n = typeof v === 'string' ? Number(v.replace(/,/g, '')) : Number(v);
  return v == null || v === '' || !Number.isFinite(n) || n <= 0 ? null : n;
}

function mathsMismatch(qty, rate, amount) {
  const q = num(qty);
  const r = num(rate);
  const a = num(amount);
  if (q == null || r == null || a == null) return false;
  return Math.abs(q * r - a) > Math.max(1, 0.01 * a);
}

export { mathsMismatch };
